export default __webpack_public_path__ + "static/media/tlmpetrolaborforc.73648589.png";